/* Birdie Coffee Finder 4Q v2.1.0. Isolated runtime; explicit cart adds and optional signup.
 * Public subscription API: https://developers.klaviyo.com/en/reference/create_client_subscription
 */
(function (scope) {
  'use strict';
  var VERSION = '2.1.0';
  if (scope.BirdieCoffeeFinder && scope.BirdieCoffeeFinder.version === VERSION) {
    if (typeof document !== 'undefined') {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scope.BirdieCoffeeFinder.initAll(); });
      else scope.BirdieCoffeeFinder.initAll();
    }
    return;
  }
  var QUESTION_DEFS = [
    {key:'caffeine', title:'How do you like your caffeine?', help:'We keep decaf separate from regular coffee.', options:[['regular','Regular'],['decaf','Decaf'],['either','Either is fine']]},
    {key:'roast', title:'Which roast do you enjoy?', help:'Choose a familiar roast, or keep your options open.', options:[['light','Light'],['medium','Medium'],['dark','Dark'],['any','Any roast']]},
    {key:'style', title:'Single origin or a blend?', help:'Single origin comes from one origin; a blend brings coffees together. Either can be a good starting point.', options:[['single-origin','Single origin'],['blend','Blend'],['any','Either is fine']]},
    {key:'format', title:'How would you like it delivered?', help:'Bagged recommendations are 12 oz. Pod recommendations are labeled by pack count.', options:[['whole-bean','Whole bean'],['ground','Ground'],['pods','K-Cup compatible pods'],['any','Any format']]}
  ];
  var FORMATS = ['whole-bean','ground','pods'];
  var CAPTURE_CONSENT = 'Yes, email me Birdie Coffee updates and offers. I can unsubscribe at any time.';
  var instances = new WeakMap();
  var instanceCount = 0;
  function text(value) { return typeof value === 'string' ? value.trim() : ''; }
  function allowed(value, values) { return values.indexOf(value) !== -1; }
  function labelFor(key, value) {
    var question = QUESTION_DEFS.find(function (q) { return q.key === key; });
    var option = question && question.options.find(function (pair) { return pair[0] === value; });
    return option ? option[1] : '';
  }
  function normalizeAnswers(input) {
    var result = {};
    QUESTION_DEFS.forEach(function (question) {
      var value = text(input && input[question.key]);
      result[question.key] = question.options.some(function (pair) { return pair[0] === value; }) ? value : '';
    });
    return result;
  }
  function answersComplete(answers) {
    var normalized = normalizeAnswers(answers);
    return QUESTION_DEFS.every(function (q) { return Boolean(normalized[q.key]); });
  }
  function safeProductUrl(value, handle) {
    var candidate = text(value) || (text(handle) ? '/products/' + encodeURIComponent(text(handle)) : '');
    if (!candidate || candidate.indexOf('//') === 0) return '';
    try {
      var url = new URL(candidate, 'https://www.birdiecoffeecompany.com');
      if (url.protocol !== 'https:' || !allowed(url.hostname, ['www.birdiecoffeecompany.com','birdiecoffeecompany.com']) ||
          url.username || url.password || url.port || !/^\/products\/[^/]+\/?$/.test(url.pathname)) return '';
      return 'https://www.birdiecoffeecompany.com' + url.pathname.replace(/\/$/, '');
    } catch (_) { return ''; }
  }
  function safeImageUrl(value) {
    if (!text(value)) return '';
    try {
      var url = new URL(value, 'https://www.birdiecoffeecompany.com');
      return url.protocol === 'https:' && !url.username && !url.password ? url.href : '';
    } catch (_) { return ''; }
  }
  function normalizeVariant(variant) {
    if (!variant || variant.available !== true || !allowed(variant.format, FORMATS)) return null;
    var id = String(variant.id == null ? '' : variant.id);
    if (!/^\d+$/.test(id) || (typeof variant.id === 'number' && !Number.isSafeInteger(variant.id))) return null;
    var title = text(variant.title);
    var format = variant.format;
    if (format !== 'pods') {
      if (Number(variant.size_oz) !== 12) return null;
      if (/\b\d+(?:\.\d+)?\s*(?:lb|lbs|pounds?)\b/i.test(title)) return null;
      var ounces = title.match(/\b(\d+(?:\.\d+)?)\s*(?:oz|ounces?)\b/i);
      if (ounces && Number(ounces[1]) !== 12) return null;
      if (format === 'ground' && /\bwhole[\s-]*bean\b/i.test(title)) return null;
      if (format === 'whole-bean' && /\bground\b/i.test(title)) return null;
      if (/\b(?:pods?|k[\s-]*cups?)\b/i.test(title)) return null;
    } else if (/\b(?:whole[\s-]*bean|ground)\b/i.test(title)) {
      return null;
    }
    return {
      id:id, title:title, format:format, size_oz:format === 'pods' ? null : 12,
      available:true,
      pack_count:format === 'pods' && Number.isInteger(variant.pack_count) && variant.pack_count > 0 ? variant.pack_count : null,
      price_cents:Number.isInteger(variant.price_cents) && variant.price_cents >= 0 ? variant.price_cents : null
    };
  }
  function normalizeCatalog(catalog) {
    var source = Array.isArray(catalog) ? catalog : catalog && catalog.products;
    var currency = !Array.isArray(catalog) && /^[A-Z]{3}$/.test(text(catalog && catalog.currency)) ? catalog.currency : 'USD';
    var seen = new Set();
    var products = (Array.isArray(source) ? source : []).map(function (product, index) {
      if (!product) return null;
      var handle = text(product.handle);
      var title = text(product.title) || text(product.name);
      var url = safeProductUrl(product.url, handle);
      if (!handle || !title || !url || seen.has(handle)) return null;
      seen.add(handle);
      var isMulligan = handle === 'the-mulligan-decaf-12oz' || handle === 'the-mulligan' || handle === 'mulligan';
      var caffeine = isMulligan ? 'decaf' : (product.caffeine === 'regular' ? 'regular' : '');
      var roast = allowed(product.roast, ['light','medium','dark']) ? product.roast : null;
      var style = allowed(product.style, ['single-origin','blend']) ? product.style : null;
      // Known current product fact. Reject a stale wrong-roast classification.
      if (handle === 'fairway-fuel' && roast !== 'medium') return null;
      var variants = (Array.isArray(product.variants) ? product.variants : []).map(normalizeVariant).filter(Boolean);
      var variantIds = new Set();
      variants = variants.filter(function (v) {
        if (variantIds.has(v.id)) return false;
        variantIds.add(v.id); return true;
      });
      return {handle:handle, title:title, url:url, image:safeImageUrl(product.image),
        caffeine:caffeine, is_mulligan:isMulligan, roast:roast, style:style,
        notes:Array.isArray(product.notes) ? product.notes.filter(function (n) { return typeof n === 'string'; }) : (text(product.notes) ? [text(product.notes)] : []),
        origin:text(product.origin), variants:variants, catalog_index:index};
    }).filter(Boolean);
    return {currency:currency, products:products};
  }
  function formatLabel(variant) {
    if (variant.format === 'pods') return (variant.pack_count ? variant.pack_count + '-count ' : '') + 'K-Cup compatible pods';
    return '12 oz · ' + (variant.format === 'whole-bean' ? 'Whole bean' : 'Ground');
  }
  function chooseVariant(variants, format) {
    var choices = variants.filter(function (v) { return format === 'any' || v.format === format; });
    if (!choices.length) return null;
    if (format === 'pods') {
      choices = choices.slice().sort(function (a, b) {
        var ap = a.pack_count === 12 ? 0 : (a.pack_count == null ? 100000 : a.pack_count);
        var bp = b.pack_count === 12 ? 0 : (b.pack_count == null ? 100000 : b.pack_count);
        return ap - bp;
      });
    }
    return choices[0];
  }
  function getRecommendations(catalog, input) {
    var answers = normalizeAnswers(input);
    var normalized = normalizeCatalog(catalog);
    if (!answersComplete(answers)) return {status:'incomplete', answers:answers, currency:normalized.currency, matches:[], total_matches:0};
    var matches = normalized.products.filter(function (product) {
      if (!product.caffeine) return false;
      if (answers.caffeine === 'regular' && product.caffeine !== 'regular') return false;
      if (answers.caffeine === 'decaf' && !product.is_mulligan) return false;
      if (answers.roast !== 'any' && product.roast !== answers.roast) return false;
      if (answers.style !== 'any' && product.style !== answers.style) return false;
      return Boolean(chooseVariant(product.variants, answers.format));
    }).map(function (product) {
      var variant = chooseVariant(product.variants, answers.format);
      var reasons = [];
      if (answers.caffeine !== 'either') reasons.push(labelFor('caffeine', answers.caffeine));
      if (answers.roast !== 'any') reasons.push(labelFor('roast', answers.roast) + ' roast');
      if (answers.style !== 'any') reasons.push(labelFor('style', answers.style));
      reasons.push(formatLabel(variant));
      return {product:product, variant:variant, reasons:reasons,
        url:product.url + '?variant=' + encodeURIComponent(variant.id)};
    });
    return {status:matches.length ? 'matched' : 'no-match', answers:answers, currency:normalized.currency,
      matches:matches.slice(0,3), total_matches:matches.length,
      explanation:matches.length ? 'These available coffees meet your choices. When more than one fits, we use catalog order; this is a starting point, not a taste guarantee.' :
        'No available product matches all your choices. Try Any roast, either style, or a different format. We will not substitute another grind, a larger bag or regular coffee for decaf.'};
  }
  function captureReady(config) {
    return Boolean(config && config.preview !== true && config.capture_enabled === true && config.capture_verified === true &&
      /^[A-Za-z0-9]{6}$/.test(text(config.klaviyo_public_key)) &&
      /^[A-Za-z0-9]{4,32}$/.test(text(config.klaviyo_list_id)));
  }
  function cartPaths(routeRoot) {
    var root = typeof routeRoot === 'string' && /^\/(?:[a-z0-9_-]+\/)*$/i.test(routeRoot) ? routeRoot : '/';
    return {add:root+'cart/add.js', get:root+'cart.js', view:root+'cart'};
  }
  function cartAvailable(config, hostname) {
    return Boolean(config && config.preview === false && allowed(hostname, ['www.birdiecoffeecompany.com','birdiecoffeecompany.com']));
  }
  function buildCartAddPayload(match) {
    var variant = normalizeVariant(match && match.variant);
    if (!variant) throw new Error('This coffee option is unavailable. Please refresh the quiz.');
    return {items:[{id:variant.id, quantity:1}]};
  }
  async function addRecommendedToCart(match, fetcher, routeRoot) {
    var payload = buildCartAddPayload(match);
    var paths = cartPaths(routeRoot);
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = controller ? setTimeout(function () { controller.abort(); },20000) : null;
    var outcome = {status:'uncertain', cart:null, cartUrl:paths.view,
      message:'We could not confirm the addition. Check your cart before trying again.'};
    try {
      try {
        var response = await fetcher(paths.add, {method:'POST', credentials:'same-origin',
          headers:{Accept:'application/json','Content-Type':'application/json'},
          body:JSON.stringify(payload), signal:controller ? controller.signal : undefined});
        if (response.ok) outcome.status = 'added';
        else {
          outcome.status = 'rejected';
          outcome.message = 'This coffee could not be added. Please review your cart or choose another coffee.';
          try {
            var errorData = await response.json();
            var description = errorData && (errorData.description || errorData.message);
            if (typeof description === 'string' && description.trim()) outcome.message = description;
          } catch (_) { /* Keep the known HTTP rejection even if its body is unreadable. */ }
          if (response.status >= 500 || response.status === 408) {
            outcome.status = 'uncertain';
            outcome.message = 'We could not confirm the addition. Check your cart before trying again.';
          }
        }
      } catch (_) { /* A failed connection can follow an accepted add; never retry the POST. */ }
      // Shopify can alter quantities even on an inventory rejection. Refresh after every outcome.
      try {
        var cartResponse = await fetcher(paths.get, {credentials:'same-origin', cache:'no-store',
          headers:{Accept:'application/json'}, signal:controller ? controller.signal : undefined});
        if (cartResponse.ok) {
          var cart = await cartResponse.json();
          if (cart && Number.isSafeInteger(cart.item_count) && cart.item_count >= 0) outcome.cart = cart;
        }
      } catch (_) { /* A failed refresh does not undo a confirmed addition. */ }
      return outcome;
    } finally { if (timeout != null) clearTimeout(timeout); }
  }
  function buildSubscriptionPayload(email, consent, recommendation, config, timestamp) {
    var cleanEmail = text(email);
    if (!captureReady(config)) throw new Error('Signup is not configured and verified.');
    if (consent !== true) throw new Error('Explicit email marketing consent is required.');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cleanEmail) || cleanEmail.length > 254) throw new Error('Enter a valid email address.');
    if (!recommendation || !answersComplete(recommendation.answers) ||
        !allowed(recommendation.status, ['matched','no-match'])) throw new Error('Complete the quiz first.');
    var properties = {
      birdie_quiz_version:VERSION, birdie_quiz_source:'Birdie Coffee Finder 4Q',
      birdie_quiz_caffeine:recommendation.answers.caffeine, birdie_quiz_roast:recommendation.answers.roast,
      birdie_quiz_style:recommendation.answers.style, birdie_quiz_format:recommendation.answers.format,
      birdie_quiz_product_handles:recommendation.matches.map(function (m) { return m.product.handle; }),
      birdie_quiz_variant_ids:recommendation.matches.map(function (m) { return m.variant.id; }),
      birdie_quiz_email_consent_text:CAPTURE_CONSENT,
      birdie_quiz_email_consent_at:timestamp || new Date().toISOString()
    };
    return {data:{type:'subscription', attributes:{custom_source:'Birdie Coffee Finder 4Q',
      profile:{data:{type:'profile', attributes:{email:cleanEmail, properties:properties,
        subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},
      relationships:{list:{data:{type:'list', id:text(config.klaviyo_list_id)}}}}};
  }
  function readJson(root, selector) {
    var element = root.querySelector(selector);
    if (!element) return null;
    try { return JSON.parse(element.textContent); } catch (_) { return null; }
  }
  function element(tag, className, content) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (content != null) node.textContent = content;
    return node;
  }
  function button(content, action, secondary) {
    var node = element('button', secondary ? 'bcq-button bcq-button--secondary' : 'bcq-button', content);
    node.type = 'button'; node.dataset.birdieQuizAction = action; return node;
  }
  function formatMoney(cents, currency) {
    if (cents == null) return 'See current price on product page';
    try { return new Intl.NumberFormat('en-US', {style:'currency',currency:currency}).format(cents / 100); }
    catch (_) { return '$' + (cents / 100).toFixed(2); }
  }
  function init(root) {
    if (!root || !root.querySelector) return null;
    if (instances.has(root)) return instances.get(root);
    var catalog = readJson(root, '[data-birdie-quiz-catalog]') || {products:[]};
    var config = readJson(root, '[data-birdie-quiz-config]') || {};
    var ui = root.querySelector('[data-birdie-quiz-ui]');
    if (!ui) { ui = element('div', 'bcq-ui'); ui.dataset.birdieQuizUi = ''; root.appendChild(ui); }
    ui.classList.add('bcq-ui');
    var uid = 'bcq-' + (++instanceCount);
    var state = {answers:{}, step:0, results:false, generation:0, request:null, skipped:false, cartPending:false};
    function cancelRequest() {
      if (state.request) { state.request.abort(); state.request = null; }
    }
    function focusHeading() {
      var heading = ui.querySelector('[data-birdie-quiz-heading]');
      if (heading) heading.focus({preventScroll:true});
    }
    function render(focus) {
      ui.replaceChildren();
      var progress = element('div','bcq-progress');
      progress.appendChild(element('p','bcq-eyebrow',state.results ? 'Your Birdie starting lineup' : 'Question ' + (state.step + 1) + ' of 4'));
      var bar = element('progress','bcq-progress__bar'); bar.max=4; bar.value=state.results ? 4 : state.step;
      bar.setAttribute('aria-label','Quiz progress'); progress.appendChild(bar); ui.appendChild(progress);
      if (state.results) renderResults(); else renderQuestion();
      if (focus) focusHeading();
    }
    function renderQuestion() {
      var question = QUESTION_DEFS[state.step];
      var fieldset = element('fieldset','bcq-question');
      var legend = element('legend','bcq-question__heading',question.title);
      legend.tabIndex=-1; legend.dataset.birdieQuizHeading=''; fieldset.appendChild(legend);
      fieldset.appendChild(element('p','bcq-help',question.help));
      var choices = element('div','bcq-choices');
      question.options.forEach(function (pair) {
        var label = element('label','bcq-choice');
        var input = document.createElement('input');
        input.type='radio'; input.name=uid+'-'+question.key; input.value=pair[0];
        input.checked=state.answers[question.key]===pair[0];
        input.addEventListener('change',function () {
          state.answers[question.key]=pair[0]; next.disabled=false;
          choices.querySelectorAll('.bcq-choice').forEach(function (l) { l.classList.toggle('is-selected',l.querySelector('input').checked); });
        });
        label.classList.toggle('is-selected',input.checked);
        label.appendChild(input); label.appendChild(element('span','',pair[1])); choices.appendChild(label);
      });
      fieldset.appendChild(choices); ui.appendChild(fieldset);
      var actions=element('div','bcq-actions');
      if(state.step>0) actions.appendChild(button('Back','back',true));
      var next=button(state.step===3?'See my coffees':'Next','next',false);
      next.disabled=!state.answers[question.key]; actions.appendChild(next);
      actions.appendChild(button('Start over','reset',true)); ui.appendChild(actions);
    }
    function renderCard(match,index,currency) {
      var card=element('article',index===0?'bcq-card bcq-card--top':'bcq-card');
      card.appendChild(element('p','bcq-eyebrow',index===0?'Your starting pick':'Another match'));
      if(match.product.image) {
        var image=document.createElement('img'); image.src=match.product.image;
        image.alt=match.product.title; image.loading='lazy'; image.width=360; image.height=360; card.appendChild(image);
      }
      card.appendChild(element('h3','bcq-card__title',match.product.title));
      card.appendChild(element('p','bcq-card__format',formatLabel(match.variant)));
      card.appendChild(element('p','bcq-card__price',formatMoney(match.variant.price_cents,currency)));
      if(match.product.origin) card.appendChild(element('p','bcq-card__detail',match.product.origin));
      if(match.product.notes.length) card.appendChild(element('p','bcq-card__detail','Tasting notes: '+match.product.notes.join(', ')));
      var reasons=element('ul','bcq-reasons');
      match.reasons.forEach(function (reason) { reasons.appendChild(element('li','',reason)); }); card.appendChild(reasons);
      var add=element('button','bcq-button','Add to cart'); add.type='button';
      add.dataset.birdieQuizCartAdd='';
      add.disabled=!cartAvailable(config,scope.location && scope.location.hostname) || typeof scope.fetch!=='function';
      card.appendChild(add);
      card.appendChild(element('p','bcq-small',config.preview===true?'Cart adds are disabled in this local preview.':'One-time purchase · Quantity 1'));
      var cartLink=element('a','bcq-cart-link','View cart');
      var routeRoot=scope.Shopify && scope.Shopify.routes && scope.Shopify.routes.root;
      cartLink.href=cartPaths(routeRoot).view; cartLink.hidden=true; card.appendChild(cartLink);
      var cartStatus=element('p','bcq-cart-status'); cartStatus.setAttribute('role','status');
      cartStatus.setAttribute('aria-live','polite'); card.appendChild(cartStatus);
      add.addEventListener('click',function () {
        if(state.cartPending || add.disabled) return;
        state.cartPending=true;
        var controls=Array.from(ui.querySelectorAll('[data-birdie-quiz-cart-add],[data-birdie-quiz-action]')).map(function (node) {
          var previous={node:node, disabled:node.disabled}; node.disabled=true; return previous;
        });
        add.textContent='Adding…'; add.setAttribute('aria-busy','true');
        cartStatus.textContent='Adding '+match.product.title+' to your cart…';
        addRecommendedToCart(match,scope.fetch.bind(scope),routeRoot).then(function (outcome) {
          if(outcome.cart) {
            var count=outcome.cart.item_count;
            document.querySelectorAll('[data-cart-count]').forEach(function (node) {
              node.textContent=String(count); node.classList.toggle('is-empty',count===0);
            });
            document.querySelectorAll('[data-header-cart-link]').forEach(function (node) {
              node.setAttribute('aria-label','Cart, '+count+' item'+(count===1?'':'s'));
            });
            document.dispatchEvent(new CustomEvent('birdie:cart-updated',{detail:outcome.cart}));
          }
          cartLink.href=outcome.cartUrl; cartLink.hidden=false;
          if(outcome.status==='added') {
            add.textContent='Added to cart'; add.dataset.birdieQuizCartLocked='true';
            cartStatus.textContent=match.product.title+' · '+formatLabel(match.variant)+' was added to your cart.'+
              (outcome.cart?'':' Open your cart to review the total.');
          } else {
            cartStatus.textContent=outcome.message;
            add.textContent=outcome.status==='uncertain'?'Check cart':'Add to cart';
            if(outcome.status==='uncertain') add.dataset.birdieQuizCartLocked='true';
          }
        }).catch(function (error) {
          cartStatus.textContent=error.message; add.textContent='Unavailable';
          add.dataset.birdieQuizCartLocked='true';
        }).finally(function () {
          state.cartPending=false; add.removeAttribute('aria-busy');
          controls.forEach(function (previous) {
            previous.node.disabled=previous.disabled || previous.node.dataset.birdieQuizCartLocked==='true';
          });
        });
      });
      return card;
    }
    function renderResults() {
      var result=getRecommendations(catalog,state.answers);
      var heading=element('h2','bcq-results__heading',result.status==='matched'?'Meet your starting lineup.':'Let’s find another starting point.');
      heading.tabIndex=-1; heading.dataset.birdieQuizHeading=''; ui.appendChild(heading);
      ui.appendChild(element('p','bcq-help',result.explanation));
      var summary=element('p','bcq-summary',QUESTION_DEFS.map(function (q) { return labelFor(q.key,state.answers[q.key]); }).join(' · ')); ui.appendChild(summary);
      if(result.matches.length) {
        var cards=element('div','bcq-cards');
        result.matches.forEach(function (match,index) { cards.appendChild(renderCard(match,index,result.currency)); }); ui.appendChild(cards);
        ui.appendChild(element('p','bcq-small','Prices shown are the selected variant’s current one-time product price, before shipping, tax or any eligible discount. Tasting notes describe the coffee’s flavor profile.'));
      }
      var actions=element('div','bcq-actions');
      actions.appendChild(button('Change my answers','edit',true)); actions.appendChild(button('Start over','reset',true)); ui.appendChild(actions);
      var capture=element('section','bcq-capture');
      if(captureReady(config) && !state.skipped) renderCapture(capture,result);
      else if(state.skipped) capture.appendChild(element('p','bcq-small','Your picks remain visible above. You can continue shopping.'));
      else capture.appendChild(element('p','bcq-small','No email is needed to view your picks. Email signup is not enabled for this quiz yet.'));
      ui.appendChild(capture);
    }
    function renderCapture(capture,result) {
      capture.appendChild(element('h3','bcq-capture__heading','Want to save your picks with Birdie?'));
      capture.appendChild(element('p','bcq-help','Optional: save these preferences and sign up for Birdie marketing emails. This does not send an emailed lineup or sign you up for texts.'));
      var form=element('form','bcq-capture__form');
      var label=element('label','bcq-label','Email address'); label.htmlFor=uid+'-email';
      var email=document.createElement('input'); email.type='email'; email.required=true; email.maxLength=254; email.autocomplete='email'; email.id=uid+'-email'; email.className='bcq-email';
      label.appendChild(email); form.appendChild(label);
      var consentLabel=element('label','bcq-consent');
      var consent=document.createElement('input'); consent.type='checkbox'; consent.required=true; consent.checked=false;
      consentLabel.appendChild(consent); consentLabel.appendChild(element('span','',CAPTURE_CONSENT)); form.appendChild(consentLabel);
      var privacy=element('a','bcq-privacy','Privacy policy');
      var privacyUrl=text(config.privacy_url);
      privacy.href=privacyUrl.indexOf('/policies/')===0 && privacyUrl.indexOf('//')!==0 ? privacyUrl : '/policies/privacy-policy';
      form.appendChild(privacy);
      var submit=element('button','bcq-button','Save my picks and sign up for Birdie emails'); submit.type='submit'; form.appendChild(submit);
      form.appendChild(button('Skip email signup','skip',true));
      var status=element('p','bcq-form-status'); status.setAttribute('role','status'); status.setAttribute('aria-live','polite'); form.appendChild(status);
      form.addEventListener('submit',function (event) {
        event.preventDefault();
        if(!form.reportValidity() || !consent.checked || !captureReady(config) || state.request) return;
        var payload;
        try { payload=buildSubscriptionPayload(email.value,consent.checked,result,config); }
        catch(error) { status.textContent=error.message; return; }
        var controller=new AbortController(); state.request=controller; var generation=state.generation;
        submit.disabled=true; submit.setAttribute('aria-busy','true'); status.textContent='Submitting your email signup request…';
        var timeout=setTimeout(function () { controller.abort(); },15000);
        fetch('https://a.klaviyo.com/client/subscriptions?company_id='+encodeURIComponent(text(config.klaviyo_public_key)), {
          method:'POST', headers:{accept:'application/vnd.api+json','content-type':'application/vnd.api+json',
            revision:/^\d{4}-\d{2}-\d{2}$/.test(text(config.klaviyo_revision))?config.klaviyo_revision:'2026-07-15'},
          body:JSON.stringify(payload),signal:controller.signal
        }).then(function (response) {
          if(!response.ok) throw new Error('Signup request was not accepted.');
          if(generation!==state.generation) return;
          email.value=''; consent.checked=false; email.disabled=true; consent.disabled=true;
          submit.hidden=true;
          status.textContent='Signup request received. If a confirmation email arrives, confirm it to finish. Your picks remain visible above.';
        }).catch(function () {
          if(generation===state.generation) status.textContent='We could not confirm your signup. Your picks are still visible. Try again, or skip email signup.';
        }).finally(function () {
          clearTimeout(timeout); if(state.request===controller) state.request=null;
          if(generation===state.generation) { submit.disabled=false; submit.removeAttribute('aria-busy'); }
        });
      });
      capture.appendChild(form);
    }
    ui.addEventListener('click',function (event) {
      if(state.cartPending) return;
      var control=event.target.closest('[data-birdie-quiz-action]');
      if(!control || !ui.contains(control) || control.disabled) return;
      var action=control.dataset.birdieQuizAction;
      if(action==='next') {
        if(!state.answers[QUESTION_DEFS[state.step].key]) return;
        if(state.step<3) state.step+=1; else state.results=true;
      } else if(action==='back') { state.step=Math.max(0,state.step-1); }
      else if(action==='edit') { cancelRequest(); state.generation+=1; state.results=false; state.step=0; state.skipped=false; }
      else if(action==='reset') { cancelRequest(); state.generation+=1; state.answers={}; state.step=0; state.results=false; state.skipped=false; }
      else if(action==='skip') { cancelRequest(); state.generation+=1; state.skipped=true; }
      else return;
      render(true);
    });
    var api={version:VERSION,reset:function () { cancelRequest(); state.generation+=1; state.answers={}; state.step=0; state.results=false; state.skipped=false; render(false); },
      getAnswers:function () { return Object.assign({},state.answers); }};
    instances.set(root,api); root.dataset.birdieQuizInitialized='true'; render(false); return api;
  }
  var core=Object.freeze({version:VERSION,questions:QUESTION_DEFS,consentText:CAPTURE_CONSENT,
    normalizeAnswers:normalizeAnswers,answersComplete:answersComplete,normalizeVariant:normalizeVariant,
    normalizeCatalog:normalizeCatalog,getRecommendations:getRecommendations,captureReady:captureReady,
    buildSubscriptionPayload:buildSubscriptionPayload,formatLabel:formatLabel,safeProductUrl:safeProductUrl,
    cartPaths:cartPaths,cartAvailable:cartAvailable,buildCartAddPayload:buildCartAddPayload,addRecommendedToCart:addRecommendedToCart});
  scope.BirdieCoffeeFinder={version:VERSION,core:core,init:init,initAll:function (context) {
    var parent=context || document;
    var roots=Array.from(parent.querySelectorAll('[data-birdie-quiz]'));
    if (parent.matches && parent.matches('[data-birdie-quiz]')) roots.unshift(parent);
    return roots.map(init);
  }};
  if(typeof document!=='undefined') {
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function () { scope.BirdieCoffeeFinder.initAll(); });
    else scope.BirdieCoffeeFinder.initAll();
    document.addEventListener('shopify:section:load',function (event) { scope.BirdieCoffeeFinder.initAll(event.target); });
  }
})(typeof globalThis!=='undefined'?globalThis:this);
